import { NgModule } from '@angular/core';
import { LayoutModule } from '../../layout/layout.module';
import { ComponentsModule } from '../../components/components.module';
import { EngenhariaRoutingModule } from './engenharia-routing.module';
import { ProjetosComponent } from './projetos/projetos.component';
import { CadastrarProjetoComponent } from './cadastrar-projeto/cadastrar-projeto.component';
import { DisciplinaComponent } from './disciplinas/disciplinas.component';
import { CadastrarDisciplinaComponent } from './cadastrar-area/cadastrar-disciplina.component';
import { RevisaoComponent } from './revisao/revisao.component';
import { ListagemValidacaoComponent } from './listagem-validacao/listagem-validacao.component';
import { ValidarProjetoComponent } from './validar-projeto/validar-projeto.component';

@NgModule({
  declarations: [
    DisciplinaComponent,
    CadastrarDisciplinaComponent,
    ListagemValidacaoComponent,
    ProjetosComponent,
    CadastrarProjetoComponent,
    ValidarProjetoComponent,
    RevisaoComponent,
  ],
  imports: [EngenhariaRoutingModule, ComponentsModule, LayoutModule],
  exports: [],
})
export class EngenhariaModule {}
